<script setup></script>

<template>
  <div
    class="bg-black opacity-30 w-screen h-screen fixed inset-0 z-BGBlack"
  ></div>
</template>
